import React from 'react';
import { CheckboxListSelector } from 'src/design/molecules/CheckboxListSelector';

interface BaseCostCodeSelectorProps {
  onChange: (codes: string[]) => void;
  value: string[];
  options: string[];
  disabled?: boolean;
}

export const BaseCostCodeSelector: React.FC<BaseCostCodeSelectorProps> = ({
  onChange,
  value,
  options,
  disabled = false,
}) => {
  return (
    <CheckboxListSelector
      items={options}
      value={value}
      onChange={onChange}
      getItemLabel={(item) => item}
      getItemId={(item) => item}
      label="Base Cost Codes"
      searchPlaceholder="Search base cost codes..."
      disabled={disabled}
      storageKey="manhours-base-cost-code-selector"
      defaultToAll
    />
  );
};
